import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "../../../images/car.svg";


class OperatorDataCard extends Component {
  state = {
    searchText: "",
    isMouseInside: false,
  };

  mouseEnter = () => {
    this.setState({ isMouseInside: true });
  };
  mouseLeave = () => {
    this.setState({ isMouseInside: false });
  };

  render() {
    const { operatorName, operatorMessage,routeType } = this.props;

    const { operator, handler } = this.props;

    return (
      <div
        className="col-md-4 mb-3"
        
        onClick={() => handler(operator)}
        style={{ cursor: "pointer" }}
      >
        <div className="bg-white p-2 rounded" style={{ position: "relative" }}>
          
          <div
            className="d-flex align-items-center"
            style={{ padding: "4px", borderRadius: "10px" }}
          >
            <div
              className="border rounded"
              style={{
                padding: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "50px",
                height: "50px",
              }}
            >
              <img
                src={logo}
                onError={(e) => {
                  e.target.src = logo;
                }}
                alt="logo"
                width="25px"
                height="auto"
                style={{ objectFit: "contain" }}
              />
            </div>
            <div
              className="ml-3"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <h2
                className="search-result-title"
                style={{ fontSize: "12px", fontWeight: "bold", margin: "0" }}
              >
                {operatorMessage}
              </h2>
              <h2
                className="search-result-desc"
                style={{ fontSize: "12px", margin: "0", color: "#7D859C" }}
              >
                {operatorName}
              </h2>
              <h2
                className="search-result-desc"
                style={{ fontSize: "10px", marginTop: "4px", color: "#7D859C" }}
              >
                {routeType}
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ selectOperatorState }) => {
  const operatorLists = selectOperatorState.operators;
  const selectedOperators = selectOperatorState.selectedOperators;
  const isSelectAll = selectOperatorState.isSelectAll;

  return {
    operatorLists,
    selectedOperators,
    isSelectAll,
  };
};

export default connect(mapStateToProps)(OperatorDataCard);
